"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var ResultAction;
(function (ResultAction) {
    ResultAction.ON_CHANGE_PAGE = 'ON_CHANGE_PAGE';
    ResultAction.CHANGE_PAGE = 'CHANGE_PAGE';
    ResultAction.SET_RESULT_PAGE = 'SET_RESULT_PAGE';
    ResultAction.SET_RESULT_ESTATE_PHASE = 'SET_RESULT_ESTATE_PHASE';
    ResultAction.ON_UPDATE_LAST_CHILD_POSITION = 'ON_UPDATE_LAST_CHILD_POSITION';
    ResultAction.SET_LAST_ITEM_POSITION = 'SET_LAST_ITEM_POSITION';
    ResultAction.CHECK_LOAD_NEXT_PAGE = 'CHECK_LOAD_NEXT_PAGE';
    ResultAction.LOAD_NEXT_PAGE = 'LOAD_NEXT_PAGE';
    ResultAction.SET_LOADING = 'SET_LOADING';
    ResultAction.LOAD_PAGE = 'LOAD_PAGE';
    ResultAction.ON_UPDATE_INFINITE_LOAD_ENABLE = 'ON_UPDATE_INFINITE_LOAD_ENABLE';
    ResultAction.SET_INFINITE_LOAD_ENALBE = 'SET_INFINITE_LOAD_ENALBE';
    ResultAction.SET_SLIDER_INITED = 'SET_SLIDER_INITED';
    ResultAction.ON_ENQUIRE_CLICKED = 'ON_ENQUIRE_CLICKED';
    ResultAction.ON_FAV_CLICKED = 'ON_FAV_CLICKED';
    ResultAction.ON_RESULT_CHANGE_VIEW = 'ON_RESULT_CHANGE_VIEW';
    ResultAction.SET_IS_SAVED = 'SET_IS_SAVED';
    ResultAction.SET_RESULT_ITEM_SAVING = 'SET_RESULT_ITEM_SAVING';
    ResultAction.SET_ITEM_IS_SAVING = 'SET_ITEM_IS_SAVING';
    ResultAction.ON_ITEM_MOUSE_UP = 'ON_ITEM_MOUSE_UP';
    ResultAction.ON_ITEM_MOUSE_DOWN = 'ON_ITEM_MOUSE_DOWN';
    ResultAction.ON_ITEM_MOUSE_ENTER = 'ON_ITEM_MOUSE_ENTER';
    ResultAction.ON_ITEM_MOUSE_LEAVE = 'ON_ITEM_MOUSE_LEAVE';
    ResultAction.ON_ITEM_MOUSE_HOVERING = 'ON_ITEM_MOUSE_HOVERING';
    ResultAction.ON_ITEM_MOUSE_HOVERING_END = 'ON_ITEM_MOUSE_HOVERING_END';
    ResultAction.ON_ITEM_CLICKED = 'ON_ITEM_CLICKED';
    ResultAction.ON_CLEAR_DISTRICT = 'ON_RESULT_CLEAR_DISTRICT';
    ResultAction.ON_BACK_TO_DISTRICT = 'ON_RESULT_BACK_TO_DISTRICT';
    ResultAction.ON_RESULT_NEW_SEARCH = 'ON_RESULT_NEW_SEARCH';
    ResultAction.ON_RESULT_SAVE_SEARCH_CLICK = 'ON_RESULT_SAVE_SEARCH_CLICK';
    ResultAction.ON_RESULT_SAVE_SEARCH_CLOSE = 'ON_RESULT_SAVE_SEARCH_CLOSE';
    ResultAction.RESULT_SHOW_SAVE_SEARCH_PROMPT = 'RESULT_SHOW_SAVE_SEARCH_PROMPT';
    ResultAction.ON_RESULT_DISTRICT_CLICK = 'ON_RESULT_DISTRICT_CLICK';
    ResultAction.ON_RESULT_CHANGE_SORT = 'ON_RESULT_CHANGE_SORT';
    ResultAction.ON_CLOSE_NO_RESULT_DIALOG = 'ON_CLOSE_NO_RESULT_DIALOG';
    ResultAction.SET_IS_MAP = 'SET_IS_MAP';
    ResultAction.CHECK_SCROLLEND = 'CHECK_SCROLLEND';
    ResultAction.onChangePage = typesafe_actions_1.createAction(ResultAction.ON_CHANGE_PAGE, function (resolve) { return function (page) { return resolve(page); }; });
    ResultAction.changePage = typesafe_actions_1.createAction(ResultAction.CHANGE_PAGE, function (resolve) { return function (page) { return resolve(page); }; });
    ResultAction.setResultPage = typesafe_actions_1.createAction(ResultAction.SET_RESULT_PAGE, function (resolve) {
        return function (results, page, pageTotal) {
            return resolve({ results: results, page: page, pageTotal: pageTotal });
        };
    });
    ResultAction.setResultEstatePhase = typesafe_actions_1.createAction(ResultAction.SET_RESULT_ESTATE_PHASE, function (resolve) {
        return function (estatePhase) {
            return resolve(estatePhase);
        };
    });
    ResultAction.onUpdateLastItemPosition = typesafe_actions_1.createAction(ResultAction.ON_UPDATE_LAST_CHILD_POSITION, function (resolve) { return function () { return resolve(); }; });
    ResultAction.setLastItemPosition = typesafe_actions_1.createAction(ResultAction.SET_LAST_ITEM_POSITION, function (resolve) { return function (position) { return resolve(position); }; });
    ResultAction.checkLoadNextPage = typesafe_actions_1.createAction(ResultAction.CHECK_LOAD_NEXT_PAGE, function (resolve) { return function (position) { return resolve(position); }; });
    ResultAction.loadNextPage = typesafe_actions_1.createAction(ResultAction.LOAD_NEXT_PAGE, function (resolve) { return function () { return resolve(); }; });
    ResultAction.setLoading = typesafe_actions_1.createAction(ResultAction.SET_LOADING, function (resolve) { return function (state) { return resolve(state); }; });
    ResultAction.loadPage = typesafe_actions_1.createAction(ResultAction.LOAD_PAGE, function (resolve) { return function (page) { return resolve(page); }; });
    ResultAction.onUpdateInfiniteLoadEnable = typesafe_actions_1.createAction(ResultAction.ON_UPDATE_INFINITE_LOAD_ENABLE, function (resolve) { return function () { return resolve(); }; });
    ResultAction.setInfiniteLoadEnable = typesafe_actions_1.createAction(ResultAction.SET_INFINITE_LOAD_ENALBE, function (resolve) { return function (state) { return resolve(state); }; });
    ResultAction.setSliderInited = typesafe_actions_1.createAction(ResultAction.SET_SLIDER_INITED, function (resolve) { return function (state) { return resolve(state); }; });
    ResultAction.onEnquireClicked = typesafe_actions_1.createAction(ResultAction.ON_ENQUIRE_CLICKED, function (resolve) { return function (item) { return resolve(item); }; });
    ResultAction.onFavClicked = typesafe_actions_1.createAction(ResultAction.ON_FAV_CLICKED, function (resolve) { return function (item) { return resolve(item); }; });
    ResultAction.onResultChangeView = typesafe_actions_1.createAction(ResultAction.ON_RESULT_CHANGE_VIEW, function (resolve) { return function (view) { return resolve(view); }; });
    ResultAction.setIsSaved = typesafe_actions_1.createAction(ResultAction.SET_IS_SAVED, function (resolve) { return function (id, state) { return resolve({ id: id, state: state }); }; });
    ResultAction.setItemsSaving = typesafe_actions_1.createAction(ResultAction.SET_RESULT_ITEM_SAVING, function (resolve) {
        return function (ids, state) { return resolve({ ids: ids, state: state }); };
    });
    ResultAction.setItemIsSaving = typesafe_actions_1.createAction(ResultAction.SET_ITEM_IS_SAVING, function (resolve) {
        return function (id, state) { return resolve({ id: id, state: state }); };
    });
    ResultAction.onMouseUp = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_UP, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onMouseDown = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_DOWN, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onMouseEnter = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_ENTER, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onMouseLeave = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_LEAVE, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onMouseHovering = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_HOVERING, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onMouseHoveringEnd = typesafe_actions_1.createAction(ResultAction.ON_ITEM_MOUSE_HOVERING_END, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onItemClicked = typesafe_actions_1.createAction(ResultAction.ON_ITEM_CLICKED, function (resolve) {
        return function (item) { return resolve(item); };
    });
    ResultAction.onClearDistrict = typesafe_actions_1.createAction(ResultAction.ON_CLEAR_DISTRICT, function (resolve) {
        return function () { return resolve(); };
    });
    ResultAction.onBackToDistrict = typesafe_actions_1.createAction(ResultAction.ON_BACK_TO_DISTRICT, function (resolve) {
        return function () { return resolve(); };
    });
    ResultAction.onNewSearch = typesafe_actions_1.createAction(ResultAction.ON_RESULT_NEW_SEARCH, function (resolve) {
        return function () { return resolve(); };
    });
    ResultAction.onSaveSearchClicked = typesafe_actions_1.createAction(ResultAction.ON_RESULT_SAVE_SEARCH_CLICK, function (resolve) {
        return function () { return resolve(); };
    });
    ResultAction.onSaveSearchClose = typesafe_actions_1.createAction(ResultAction.ON_RESULT_SAVE_SEARCH_CLOSE, function (resolve) {
        return function () { return resolve(); };
    });
    ResultAction.showSaveSearchPrompt = typesafe_actions_1.createAction(ResultAction.RESULT_SHOW_SAVE_SEARCH_PROMPT, function (resolve) {
        return function (page) { return resolve(page); };
    });
    ResultAction.onDistrictClick = typesafe_actions_1.createAction(ResultAction.ON_RESULT_DISTRICT_CLICK, function (resolve) {
        return function (districtName, districtId) {
            return resolve({ districtName: districtName, districtId: districtId });
        };
    });
    ResultAction.onChangeSort = typesafe_actions_1.createAction(ResultAction.ON_RESULT_CHANGE_SORT, function (resolve) { return function (sortId) { return resolve(sortId); }; });
    ResultAction.onCloseNoResultDialog = typesafe_actions_1.createAction(ResultAction.ON_CLOSE_NO_RESULT_DIALOG, function (resolve) { return function () { return resolve(); }; });
    ResultAction.setIsMap = typesafe_actions_1.createAction(ResultAction.SET_IS_MAP, function (resolve) { return function (state) { return resolve(state); }; });
    ResultAction.checkScrollEnd = typesafe_actions_1.createAction(ResultAction.CHECK_SCROLLEND, function (resolve) { return function () { return resolve(); }; });
})(ResultAction || (ResultAction = {}));
exports.default = ResultAction;
